import { Injectable } from '@angular/core';
import { HttpService } from '../../utils/services/http.service';
import { ErrorsService } from '../../utils/services/errors.service';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class DashboardService {

  constructor(
    private httpService: HttpService,
    private errorsService: ErrorsService
  ) { }

  /* Get dashboard details from the Backend for Admin module*/
  getDashboardDeatils() {
    return this.httpService.get(`admin/dashboard`)
      .map((res: Response) => res.json())
      .catch((error: any) => {
        return this.handleError(error);
      });
  }

  getGlobalSettingsCDMO() {
    return this.httpService.get(`getBusinessUnitCdmo`)
      .map((res: Response) => res.json())
      .catch((error: any) => {
        return this.handleError(error);
      });
  }
  getGlobalSettingsDiscovery() {
    return this.httpService.get(`getBusinessUnitDiscovery`)
      .map((res: Response) => res.json())
      .catch((error: any) => {
        return this.handleError(error);
      });
  }

  getGlobalSettingsAPSL() {
    return this.httpService.get(`getBusinessUnitTotal`)
      .map((res: Response) => res.json())
      .catch((error: any) => {
        return this.handleError(error);
      });
  }

  // Add project
  updateHeadCount(data) {
    return this.httpService
      .put(`updateHeadCount`, data)
      .map((res: Response) => res.json())
      .catch((error: any) => {
        return this.handleError(error);
      });
  }



  /*Get the Audit data from the backend with default size per page as 15*/
  getAuditLog(pageNumber) {
    const data = {
      'pageSize': 15,
      'pageNumber': pageNumber
    };
    return this.httpService.post(`auditlogs`, data)
      .map((res: Response) => res.json())
      .catch((error: any) => {
        return this.handleError(error);
      });
  }

  /**
  * @function handleError()
  * @description
  * Function to handle the Subscription used while calling API
  * Observable error from rxjs will be thrown
  * @author Abhiraj SN
 */
  handleError(error: any) {
    this.errorsService.handleError(error);
    return Observable.throw(error.json());
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/dashboard/dashboard.service.ts